export const UPEVENTS = {
  TEAM_CREATED: "team_created_successfully",
  USER_ADDED: "user_added_successfully",
  CARD_ADDED: "credit_card_added_successfully",
  INVOICE_ENABLED: "invoice_enabled_successfully",
};

export function upTrack(name) {
  if (window?.userpilot?.track) {
    console.log("Userpilot event tracked");
    window.userpilot.track(name);
  } else {
    window.__upQueue = window.__upQueue || [];
    window.__upQueue.push({ name });
    setTimeout(() => {
      if (window?.userpilot?.track && window.__upQueue?.length) {
        for (const e of window.__upQueue) window.userpilot.track(e.name);
        window.__upQueue = [];
      }
    }, 1000);
  }
}
